/** Max messages kept per user + group + surface in IndexedDB (FIFO). */
export const MAX_PERSISTED_AI_CHAT_MESSAGES = 50;

/** Debounce delay before writing chat state to IndexedDB. */
export const AI_CHAT_PERSIST_DEBOUNCE_MS = 600;

export const AI_CHAT_INDEXED_DB_NAME = 'mani-ai-chat';
export const AI_CHAT_INDEXED_DB_VERSION = 1;
export const AI_CHAT_INDEXED_DB_STORE = 'threads';
